
import { oz } from '@weft/utils';
import { CreditPromotionConfigurationInputSchema } from '../promotion-configuration-input-schemas';
import { PROMOTION_TYPES } from '../promotion-type-schema';

export const CreditPromotionModelInputSchema = oz.object({
  promotionType: oz.literal(PROMOTION_TYPES.Credit),
  promotionConfiguration: CreditPromotionConfigurationInputSchema,
}).openapi('CreditPromotionModelInput');

export type CreditPromotionModelInput = oz.infer<typeof CreditPromotionModelInputSchema>;